export default "https://cdn-web.disco.co/default-product-card-cover-bb8f9434c7985795de357561cae938b3.png";